export class VoucherSKUValue {

    constructor(
        public id: string,
        public skuId: string,
        public amount: number,
        public dateCreated: Date,
        public dateUpdated: Date
    ) { }
}
